<template>
    <div :style="{ width: width, height: height }">
        <canvas ref="canvas" style="width: 100%; height: 100%;"></canvas>
    </div>
</template>

<script>
import SignaturePad from 'signature_pad';

export default {
    name: 'VueSignaturePad',
    props: {
        width: { type: String, default: '100%' },
        height: { type: String, default: '200px' },
        options: { type: Object, default: () => ({}) },
    },

    data() {
        return {
            signaturePad: null,
        };
    },

    mounted() {
        const canvas = this.$refs.canvas;
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
        this.signaturePad = new SignaturePad(canvas, this.options);

        // Resize canvas when window resizes
        this._resizeHandler = () => {
            const data = this.signaturePad.toData();
            canvas.width = canvas.offsetWidth;
            canvas.height = canvas.offsetHeight;
            this.signaturePad.clear();
            this.signaturePad.fromData(data);
        };
        window.addEventListener('resize', this._resizeHandler);
    },

    unmounted() {
        if (this._resizeHandler) {
            window.removeEventListener('resize', this._resizeHandler);
        }
        if (this.signaturePad) {
            this.signaturePad.off();
        }
    },

    methods: {
        saveSignature(type = 'image/png') {
            const isEmpty = this.signaturePad.isEmpty();
            const data = isEmpty ? null : this.signaturePad.toDataURL(type);
            return { isEmpty, data };
        },

        clearSignature() {
            this.signaturePad.clear();
        },

        undoSignature() {
            const data = this.signaturePad.toData();
            if (data.length > 0) {
                data.pop();
                this.signaturePad.fromData(data);
            }
        },

        isEmpty() {
            return this.signaturePad.isEmpty();
        },
    },
};
</script>
